import {Box, BoxProps} from '@chakra-ui/react'
import {LuExternalLink} from 'react-icons/lu'

export type ResourceTagBehavior = 'none' | 'open-drawer'

export interface ResourceTagProps extends BoxProps {
  behavior?: ResourceTagBehavior
  onClick?: (e: React.MouseEvent) => void
  coloredAsLink?: boolean
  withExternalIcon?: boolean
}

export function ResourceTag({
  children,
  behavior = 'open-drawer',
  coloredAsLink = true,
  withExternalIcon,
  ...props
}: ResourceTagProps) {
  if (behavior === 'open-drawer')
    return (
      <Box
        as="button"
        cursor="pointer"
        display="flex"
        gap="2"
        alignItems="center"
        color={coloredAsLink ? 'cyan.fg' : undefined}
        // textDecoration={coloredAsLink ? 'underline' : undefined}
        {...props}
        onClick={e => {
          e.stopPropagation()
          props.onClick?.(e)
        }}
      >
        {children}
        {withExternalIcon && <LuExternalLink />}
      </Box>
    )

  return <Box {...props}>{children}</Box>
}
